import { render, staticRenderFns } from "./StoryList.vue?vue&type=template&id=22ffae9a"
import script from "./StoryList.vue?vue&type=script&lang=js"
export * from "./StoryList.vue?vue&type=script&lang=js"
import style0 from "./StoryList.vue?vue&type=style&index=0&id=22ffae9a&prod&lang=scss"
import style1 from "./StoryList.vue?vue&type=style&index=1&id=22ffae9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports